import React from "react";
import { ApplicationState } from "../store";
import { InsuranceStartState, actions } from "../store/Insurance";
import { connect } from "react-redux";
import { DateTimePickerGroupBase } from "./DateTimePickerGroupBase";
import { useLocalValidation } from "../hooks/useLocalValidation";

type InsuranceStartProps = InsuranceStartState & {
  onChange: Function;
  forwardedRef?: React.RefObject<HTMLDivElement>;
};

const getStringDate = (value: Date | undefined): string => {
  if (value === undefined || isNaN(value.getTime())) return "";
  const fullDateString = value.toISOString();
  return fullDateString.split("T")[0];
};

const getValidationState = (date: Date | undefined, hasError: boolean | undefined) => {
  if (!hasError) {
    return 0;
  }
  if (hasError && !date) {
    return 1; //empty field value
  }
  return 2; //invalid field value
};

export const InsuranceStartDatePicker: React.FC<InsuranceStartProps> = (props: InsuranceStartProps) => {
  useLocalValidation({
    fieldName: "insuranceStartDate",
    state: getValidationState(props.value, props.hasError),
    value: getStringDate(props.value),
    errorMessage: props.helperText || "",
  });

  return (
    <DateTimePickerGroupBase
      forwardedRef={props.forwardedRef}
      input={{
        onChange: props.onChange,
        value: props.value,
        hasError: props.hasError,
        helperText: props.helperText,
        isDisabled: props.isDisabled,
        id: "datepicker",
      }}
      label={{
        title: props.title,
      }}
    />
  );
};

const stateToProps = (state: ApplicationState) => state.insurance?.startDate;
const dispatcherToProps = {
  onChange: actions.insuranceStartDateChanged,
};

export default connect(stateToProps, dispatcherToProps)(InsuranceStartDatePicker);
